import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress "Script error" from cross-origin YouTube iframes
// This prevents the React dev overlay from showing for these harmless errors
window.addEventListener('error', (event) => {
  if (event.message === 'Script error.' || 
      event.message?.includes('Script error') ||
      event.filename === '') {
    event.stopImmediatePropagation();
    event.preventDefault();
    return true;
  }
}, true);

// Also suppress unhandled promise rejections from YouTube
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason?.message?.includes('Script error') ||
      event.reason?.toString()?.includes('cross-origin')) {
    event.stopImmediatePropagation();
    event.preventDefault();
    return true;
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
